/**
 * ============================================================================
 * BESTSELLER COMPONENT
 * ============================================================================
 *
 * Simplified component that only handles slideshow functionality
 * Add-to-cart is now handled by custom elements in the product cards
 *
 * ============================================================================
 */

/**
 * Bestseller Component Class
 */
class BestsellerComponent {
  constructor() {
    this.sections = document.querySelectorAll('.section-bestseller');
    this.debug = window.Shopify && window.Shopify.designMode;

    if (this.debug) {
      console.log('BestsellerComponent initialisiert. Gefundene Sections:', this.sections.length);
    }

    this.init();
  }

  /**
   * Initialize component
   */
  init() {
    // Warte auf DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initSections());
    } else {
      this.initSections();
    }

    // Shopify Section Events
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('section-bestseller')) {
        this.initSection(event.target);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.classList.contains('section-bestseller')) {
        this.destroySection(event.target);
      }
    });
  }

  /**
   * Initialize all sections
   */
  initSections() {
    this.sections.forEach(section => this.initSection(section));
  }

  /**
   * Initialize single section
   */
  initSection(section) {
    if (!section) {
      if (this.debug) {
        console.warn('Bestseller Section ist null oder undefined');
      }
      return;
    }

    const sectionId = section.id || `bestseller-${Date.now()}`;

    if (this.debug) {
      console.log('Initialisiere Bestseller Section:', sectionId);
    }

    // Initialize slideshow if present
    this.initSlideshow(section);
  }

  /**
   * Initialize slideshow functionality
   */
  initSlideshow(section) {
    const swiperContainer = section.querySelector('.bestseller-swiper');
    if (!swiperContainer) return;

    // Slideshow initialization logic here if needed
    if (this.debug) {
      console.log('Slideshow gefunden in Section:', section.id);
    }
  }

  /**
   * Destroy section
   */
  destroySection(section) {
    // Cleanup wenn nötig
    if (this.debug) {
      console.log('Bestseller Section zerstört:', section.id);
    }
  }

  /**
   * Destroy component
   */
  destroy() {
    // Remove event listeners if needed
    // Currently using event delegation, so no cleanup needed
  }
}

/**
 * Initialize Bestseller components
 */
function initBestseller() {
  // Erstelle eine globale Instanz falls noch nicht vorhanden
  if (!window.bestsellerInstance) {
    window.bestsellerInstance = new BestsellerComponent();
  }
  return window.bestsellerInstance;
}

/**
 * Auto-initialize when DOM is ready
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBestseller);
} else {
  initBestseller();
}

/**
 * Make available globally for manual initialization
 */
window.BestsellerComponent = BestsellerComponent;
window.initBestseller = initBestseller;

/**
 * Register with global theme app if available
 */
if (window.CustomThemeApp && window.CustomThemeApp.registerModule) {
  window.CustomThemeApp.registerModule('bestseller', {
    init: initBestseller,
    BestsellerComponent
  });
}
